const TechnologyTitle = () => {
    return <h5 className="w-lg-75 d-flex justify-content-center">
    <span className="text-secondary m-2 ms-5">03 </span>
    <span className="fw-light m-2"> SPACE LAUNCH 101</span>
  </h5>
}
 
export default TechnologyTitle;